import { SensorConfigFormShape } from '@Types/configurations.types';
import { EnclosingHelpers, QuoteFormat } from './enclosing-helpers';

export type QueryResultsPeek = [unknown, unknown][];

export enum DbType {
	MSSQL = 'MSSQL',
	ORACLE = 'ORACLE',
	MYSQL = 'MYSQL',
}

type EncloseRequest = {
	data: SensorConfigFormShape;
	quoteFormat: QuoteFormat;
	tagFormat: string;
};

export class PayloadPeekMethods {
	private constructor() {
		// ? noop
	}

	public static toEnclosed(req: EncloseRequest): SensorConfigFormShape {
		const { data, quoteFormat, tagFormat } = req;
		const tagQuotingFormat =
			tagFormat === 'NUMBER'
				? EnclosingHelpers.NO_QUOTE
				: EnclosingHelpers.SINGLE_QUOTE;
		const enclosedTagValue = EnclosingHelpers.encloseField(
			data.tagValue,
			tagQuotingFormat,
		);
		const enclosedSensorId = EnclosingHelpers.encloseField(
			data.sensorId,
			tagQuotingFormat,
		);
		return {
			...data,
			sensorChannelField: EnclosingHelpers.encloseField(
				data.sensorChannelField,
				quoteFormat,
			),
			sensorDateField: EnclosingHelpers.encloseField(
				data.sensorDateField,
				quoteFormat,
			),
			sensorTable: EnclosingHelpers.encloseField(
				data.sensorTable,
				quoteFormat,
			),
			sensorIdField: EnclosingHelpers.encloseField(
				data.sensorIdField,
				quoteFormat,
			),
			tagValue: enclosedTagValue,
			sensorId: enclosedSensorId,
		};
	}
}
